import { DeepPartial, Messages } from '@empathybroker/ebx-gluon';

export const es: DeepPartial<Messages> = {
  resultsFoundHTML: 'Resultado de búsqueda <span class="ebx-results-number__count">{resultsNumber}</span>',
  nextQueriesSuggestions: {
    title: 'Quien buscó {query} también buscó...'
  },
  search: {
    inputPlaceholderAlternativesHTML: ['¿Qué estás buscando?']
  },
  history: {
    title: 'Mis últimas búsquedas',
    clear: 'Borrar todas'
  },
  recommendations: {
    title: 'Productos recomendados'
  }

};
